export const DATE_FORMAT = {
    MONTH_YEAR: 'MMMM YYYY',
    MONTH_NAME: 'MMMM',
    DAY_MONTH: 'DD. MMM',
    YEAR: 'YYYY',
    DAY_MONTH_YEAR: 'DD. MMM YYYY',
    DATE_MONTH_YEAR: 'DD.MM.YYYY',
    DAY_NAME_MONTH_NAME_DAY_YEAR: 'ddd DD. MMM YYYY',
    FULL_DATE_TIME: 'ddd DD. MMM YYYY HH:mm:ss',
    BASIC_DATA_YEAR: 'DD/MM/YYYY',
    SERVER_DATE: 'YYYY-MM-DD'
};

// Excel-compatible date formats for sortable exports
export const EXCEL_DATE_FORMAT = {
    DATE: 'DD/MM/YYYY', // For date-only fields (sortable in Excel)
    TIMESTAMP: 'DD/MM/YYYY HH:mm:ss' // For datetime fields with time (sortable in Excel)
};
